export const MapBackgroundSwitchTemplate = `
    <div id="map-background-switch" class="">
        <div id="layer-button.radio-vector" class="button-item">
            <label class="form-radio-label" for="radio-vector"><img src="/assets/icons/legend_vector.png" alt="layer icon" width="60px" height="40px"></label>
        </div>

        <div id="layer-button.radio-hybrid" class="button-item">
            <label class="form-radio-label" for="radio-hybrid"><img src="/assets/icons/legend_hybrid.png" alt="layer icon" width="60px" height="40px"></label>
        </div> 
    </div>
`;
